import { render, staticRenderFns } from "./CalendarOrganizerMeetingSlot.vue?vue&type=template&id=284a2232&scoped=true&"
import script from "./CalendarOrganizerMeetingSlot.vue?vue&type=script&lang=ts&"
export * from "./CalendarOrganizerMeetingSlot.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarOrganizerMeetingSlot.vue?vue&type=style&index=0&id=284a2232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a2232",
  null
  
)

export default component.exports